import React from 'react';

import { Avatar, Box, Chip, Text, useTheme } from '@ublend-npm/aulaui-core';

type ParticipantHistoryAccordionItemProps = {
  avatar?: string;
  isEducator: boolean;
  firstName: string;
  lastName: string;
};

const ParticipantHistoryAccordionItem = ({
  avatar,
  isEducator,
  firstName,
  lastName,
}: ParticipantHistoryAccordionItemProps) => {
  const theme = useTheme();

  const initials = `${firstName?.substring(0, 1)?.toUpperCase() || ''}${
    lastName?.substring(0, 1)?.toUpperCase() || ''
  }`;

  return (
    <Box
      sx={{
        py: 1,
        px: 2.5,
        my: 1,
        backgroundColor: theme.palette.background.default,
        borderRadius: 1,
        display: 'flex',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <Avatar
        src={avatar}
        fallbackText={initials}
        sx={{ width: 32, height: 32 }}
      />
      <Text>
        {firstName} {lastName}
        {isEducator ? (
          <Box sx={{ display: 'inline-block', mx: 1 }}>
            <Chip
              sx={{
                backgroundColor: theme.palette.secondary.main,
                cursor: 'default',
              }}
              kind="primary"
              size="small"
              label="Educator"
            />
          </Box>
        ) : (
          ' '
        )}
      </Text>
    </Box>
  );
};

export default ParticipantHistoryAccordionItem;
